module.exports = __webpack_public_path__ + "static/media/increase-size.9f22dfd3.svg";